import { createSlice } from "@reduxjs/toolkit";

const selectedNewsletterSlice = createSlice({
    name: "selectedNewsletter",
    initialState: {
        newsletter: null, // for single newsletter object
    },
    reducers: {
        setSelectedNewsletter: (state, action) => {
            state.newsletter = action.payload; // store the newsletter
        },
        clearSelectedNewsletter: (state) => {
            state.newsletter = null; // optional: clear when done
        },
    },
});

export const { setSelectedNewsletter, clearSelectedNewsletter } = selectedNewsletterSlice.actions;
export default selectedNewsletterSlice.reducer;
